<template>
  <round :device="device">
    <div slot="left">
      <img @click="changeTemp(-1)" src="../assets/images/device/aircon/jx.png" style="height: 25px"/>
    </div>
    <div class="air-tmp">
      <div>
        <span v-text="tt" v-if="changing"></span>
        <span v-text="device.state.tt || '--'" v-else></span>
        <span>°</span>
      </div>
      <div>
        <img :src="air.icon" style="width: 12px"/><span v-text="air.text"></span>
      </div>
    </div>
    <img slot="right" @click="changeTemp(1)" src="../assets/images/device/aircon/zj.png"
         style="height: 25px;margin-top: 29px"/>
    <div slot="footer" class="footer">
      <div>
        <div>
          <span class="radius" cool @click="changeMode('cold')" :selected="device.state.mode===0"></span>
        </div>
        <div>
          <span>制冷</span>
        </div>
      </div>
      <div>
        <div>
          <span class="radius" warm @click="changeMode('heat')" :selected="device.state.mode===1"></span>
        </div>
        <div>
          <span>制热</span>
        </div>
      </div>
      <div>
        <div>
          <span class="radius" more @click="showMore">
            <span></span>
            <span></span>
            <span></span>
          </span>
        </div>
        <div>
          <span>更多</span>
        </div>
      </div>
    </div>
  </round>
</template>
<script>
import Round from './Round'
import { Message } from 'element-ui'
import api from '../model/device'

export default {
  name: 'LoraAirCondition',
  data () {
    return {
      tt: 0,
      changing: false,
      timeout: null
    }
  },
  props: {
    device: {
      type: Object,
      required: true
    }
  },
  computed: {
    air () {
      if (this.device.state.air === 1) {
        return { text: '低风速', icon: require('../assets/images/device/aircon/low.png') }
      } else if (this.device.state.air === 2) {
        return { text: '中风速', icon: require('../assets/images/device/aircon/middle.png') }
      } else if (this.device.state.air === 3) {
        return { text: '高风速', icon: require('../assets/images/device/aircon/high.png') }
      } else {
        return { text: '低风速', icon: require('../assets/images/device/aircon/low.png') }
      }
    }
  },
  components: {
    Round
  },
  mounted () {
    this.tt = this.device.state.tt || 16
  },
  methods: {
    async changeMode (mode) {
      try {
        await api.singleControl(this.device, mode)
      } catch (e) {
        Message.error(e.message)
      }
    },
    changeTemp (value) {
      this.timeout && clearTimeout(this.timeout)
      this.changing = true
      // this.tt += value
      value > 0 ? ++this.tt : --this.tt
      if (this.tt > 30) {
        this.tt = 30
      } else if (this.tt < 16) {
        this.tt = 16
      }
      this.timeout = setTimeout(() => {
        this.sendCommand()
      }, 400)
    },
    async sendCommand () {
      // 执行
      try {
        await api.singleControl(this.device, 'temp', this.tt)
      } catch (e) {
        Message.error(e.message)
      } finally {
        this.changing = false
      }
    },
    showMore () {
      this.$router.push({ name: 'loraaircondition', params: { id: this.device.id, device: this.device } })
    }
  }
}
</script>
<style scoped lang="less">
.round {
  .middle {
    > div:nth-child(2) {
      > div:first-child {
        font-size: 50px;
        font-weight: 300;
        color: rgba(139, 214, 255, 1);
      }
      > div:last-child {
        margin-top: -10px;
        font-size: 12px;
        font-weight: 400;
        color: rgba(89, 89, 89, 1);
        line-height: 17px;
        img {
          margin-right: 4px;
          vertical-align: middle;
        }
      }
      flex: 1;
    }
    > div:last-child, div:first-child {
      width: 53px;
    }
    .air-tmp {
      text-align: center;
      > div:first-child {
        width: 100%;
        text-align: center;
        padding-left: 5px
      }
      > div:last-child {
        padding-right: 10px;
      }
    }
  }
  .footer {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    text-align: center;
    font-size: 12px;
    font-weight: 400;
    color: rgba(89, 89, 89, 1);
    .radius {
      display: inline-block;
      width: 45px;
      height: 45px;
      cursor: pointer;
      border-radius: 50%;
      box-shadow: 0px 5px 16px 2px rgba(61, 130, 229, 0.08);
      background-color: white;
    }

    .radius[warm] {
      background: url("../assets/images/device/aircon/hot.png") no-repeat center;
      background-size: 24px;
    }

    .radius[cool] {
      background: url("../assets/images/device/aircon/cool.png") no-repeat center;
      background-size: 24px;
    }

    .radius[more] {
      background: rgba(255, 255, 255, 1);
      box-shadow: 0px 5px 16px 2px rgba(85, 85, 85, 0.08);
      display: flex;
      justify-content: center;
      align-items: center;
      margin-bottom: 4px;
    }

    .radius[more] > span {
      display: inline-block;
      background: rgba(85, 85, 85, 1);
      border-radius: 50%;
      height: 4px;
      width: 4px;
      margin-right: 4px;
    }

    .radius[more] > span:last-child {
      margin-right: 0;
    }

    .radius[selected][warm] {
      background: url("../assets/images/device/aircon/hot_e.png") no-repeat center;
      background-size: 24px;
      background-color: #32D374;
    }
    .radius[selected][cool] {
      background: url("../assets/images/device/aircon/cool_e.png") no-repeat center;
      background-size: 24px;
      background-color: #32D374;
    }
  }
}
</style>
